import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "passwordCount" })
export class PasswordCountPipe implements PipeTransform {
  transform(value: string, peak: number): any { //eslint-disable-line
    peak = isFinite(peak) ? peak : 8;

    return value && value.length > peak ? peak + "+" : value.length;
  }
}
